<template>
  <v-dialog v-model="dialog" width="90%">

    <v-card elevation="3">
      <div class="pp-sidenav">
        <v-card-title class="white--text">
          Edit a Review
        </v-card-title>

        <v-card-subtitle class="white--text">
          Amend details below
        </v-card-subtitle>
      </div>

      <v-img
          src="/images/pp-logo.png"
          height="40"
          contain
          class="logo-course"
      >
      </v-img>

      <v-tabs
          dark
          width="250"
          color="primary"
          vertical
      >
        <v-tab class="pp-sidenav-2">
          <v-icon left>
            mdi-pencil
          </v-icon>
          Edit a review
        </v-tab>

        <v-tab-item>
          <v-card flat v-if="currentScormCourseItem">
            <v-container>
              <template>
                <v-card
                    color="grey lighten-4"
                    width="100%" flat
                >
                  <v-card-title class="text-h6 grey lighten-3">
                    Edit <span class="primary--text ml-2"> {{ currentScormCourseItem.originalName }} </span>
                    <v-icon class="ml-1">mdi-chevron-right</v-icon>
                  </v-card-title>

                  <v-card-title class="mb-10">

                    <div class="pa-3">
                      <v-card-title>
                        Update SCORM File
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-file-input
                              show-size
                              label="Select a SCORM .zip file"
                              accept=".zip"
                              placeholder="Select a SCORM .zip file"
                              persistent-hint
                              hint="1. Must be a .zip file. 2. Must be a valid SCORM package."
                              solo
                              flat
                              v-model="editableScormCourseItem.file"
                              style="width: 100%"
                              height="150"
                              class="mb-5"
                          ></v-file-input>
                        </v-row>
                        <v-row
                            v-if="scormCourseApiError && scormCourseApiError.fields && scormCourseApiError.fields.file">
                          <p class="error--text">
                            SCORM file must be chosen.
                          </p>
                        </v-row>
                      </v-card-text>
                    </div>
                  </v-card-title>
                  <v-row v-if="scormCourseApiError">
                    <v-alert
                        text
                        color="red"
                        icon="mdi-alert-circle-outline"
                    >
                      There was an error in submission. Please check all fields and try again.
                    </v-alert>
                  </v-row>
                </v-card>
              </template>
            </v-container>
          </v-card>
          <div v-else>
            <UnavailableContent />
          </div>
        </v-tab-item>
      </v-tabs>

      <!-- ------------------------------------------ buttons ------------------------------------------ -->
      <div class="pp-sidenav">
        <div class="btm">
          <Loading v-if="scormCourseItemLoading"/>
          <ConfirmCancelButtons
              :item="currentScormCourseItem"
              :confirm-disabled="scormCourseItemLoading"
              :confirm-action="editItemConfirm"
              :cancel-action="closeDialog"
              confirm-text="Save Changes"/>
        </div>
      </div>
      <!-- ------------------------------------------end of buttons ------------------------------------------ -->
    </v-card>
  </v-dialog>
</template>

<script>
import Loading from "@/components/common/Loading";
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import { mapActions, mapGetters } from "vuex";
import UnavailableContent from "@/components/common/UnavailableContent";

export default {
  name: "ScormEdit",
  components: {UnavailableContent, Loading, ConfirmCancelButtons},
  computed: {
    ...mapGetters([
      'scormCourseApiError', 'openDialog', 'currentScormCourseItem', 'editableScormCourseItem',
      'scormCourseItemLoading',
    ]),
    dialog: {
      get () {
        return this.openDialog === 'scormEdit';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['editScormCourse', 'clearScormCourseItems', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.closeOpenDialog();
      this.clearScormCourseItems();
    },
    async editItemConfirm() {
      const edited = await this.editScormCourse(this.editableScormCourseItem);

      if (edited) {
        this.closeOpenDialog();
      }
    },
  },
};
</script>
